const typeOf = obj =>
  ({}.toString
    .call(obj)
    .match(/\s([a-z|A-Z]+)/)[1]
    .toLowerCase())

export const isArray = obj => typeOf(obj) === 'array'
export const isRegexp = obj => typeOf(obj) === 'regexp'
export const isObject = obj => typeOf(obj) === 'object'
export const isError = obj => typeOf(obj) === 'error'
export const isDate = obj => typeOf(obj) === 'date'
export const isNumber = obj => typeOf(obj) === 'number'
export const isString = obj => typeOf(obj) === 'string'
export const isBoolean = obj => typeOf(obj) === 'boolean'
export const isFunction = obj => typeOf(obj) === 'function'
